export default "__VITE_ASSET__rwThXkj5__"